import { clearSessionToken, getSessionToken } from './sessionToken';

const PUBLIC_AUTH_PATHS = new Set([
  '/api/auth/bootstrap', '/api/auth/login', '/api/auth/status',
  '/api/auth/permissions', '/api/auth/handoff/redeem', '/api/tma/auth',
]);

/** Attach sessions only to our API; callers retain their explicit headers. */
export function authenticatedFetch(original: typeof fetch, apiOrigin: string): typeof fetch {
  return async (input, init) => {
    const rawUrl = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    let url: URL;
    try { url = new URL(rawUrl, window.location.href); } catch { return original(input, init); }
    if (url.origin !== apiOrigin || PUBLIC_AUTH_PATHS.has(url.pathname)) return original(input, init);

    const headers = new Headers(typeof Request !== 'undefined' && input instanceof Request ? input.headers : undefined);
    new Headers(init?.headers).forEach((value, key) => headers.set(key, value));
    const token = getSessionToken();
    if (token && !headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
    const sentToken = /^Bearer\s+(.+)$/i.exec(headers.get('Authorization') || '')?.[1];
    const response = await original(input, { ...init, headers });
    // UI closes immediately through the shared session subscription. Never
    // reload/replay a mutation, or clear a fresh session for a late old 401.
    // /me handles its own auth result in AuthContext.
    if (response.status === 401 && sentToken && url.pathname !== '/api/auth/me') clearSessionToken(sentToken);
    return response;
  };
}
